import { AlertService, IPromptDialogData } from '@aurelia-toolkit/alert';
import { IWidget, WidgetBase, WidgetPropertyType } from '@dynamik/common';
import { autoinject, bindable, TaskQueue } from 'aurelia-framework';
import { IPropertyMetadata } from 'common/src/widgets/i-property-metadata';

@autoinject
export class ReportWidgetProperties {
  constructor(private root: Element, private alertService: AlertService, private taskQueue: TaskQueue) { }

  propertyGroups: { group: string; properties: IPropertyMetadata[] }[];
  WidgetPropertyType = WidgetPropertyType

  @bindable
  widgetVm: WidgetBase;
  async widgetVmChanged() {
    if (!this.widgetVm) {
      return;
    }
    const allProps = this.widgetVm.properties.filter(x => x.group !== null);
    for (const p of allProps) {
      if (this.widgetVm[`${p.name}ListValues`]) {
        p.listValues = await this.widgetVm[`${p.name}ListValues`]();
      }
    }

    this.propertyGroups = [];
    // reset properties first so that Aurelia disposes of the old elements
    // not doing this will cause property values leaking between widgets
    this.taskQueue.queueTask(() => this.propertyGroups = Array.from(allProps.groupBy(x => x.group)).map(([group, properties]) => ({ group, properties })));
  }

  @bindable
  widget: IWidget = undefined;

  removeWidget(w: IWidget) {
    this.root.dispatchEvent(new CustomEvent('remove', { bubbles: true, detail: w }));
  }

  async parameterisedChanged(propertyName: string, event: Event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.target['checked']) {
      const params: Partial<IPromptDialogData> = { required: true, text: propertyName, label: 'Parameter name', cancelText: 'Cancel', okText: 'OK' };
      if (await this.alertService.prompt(params)) {
        this.widgetVm.parameterisedProperties[propertyName] = params.text;
      }
    }
    else {
      this.widgetVm.parameterisedProperties[propertyName] = undefined;
    }
    this.root.dispatchEvent(new CustomEvent('change', { bubbles: true }));
  }
}
